module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CartItemAmount":{"modal":{"title":"Odebrat zboží?","remove":"Odebrat zboží","cancel":"Neodebrat"}}}}')
  delete Component.options._Ctor
}
